/**
 * Release Notes Configuration
 *
 * Update this file with new version information when releasing updates.
 * The dialog will automatically show to users who haven't seen this version yet.
 */

export interface ReleaseNote {
  version: string;
  date: string;
  notes: {
    en: {
      title: string;
      items: string[];
    };
    'zh-HK': {
      title: string;
      items: string[];
    };
    'zh-CN': {
      title: string;
      items: string[];
    };
  };
}

export const CURRENT_RELEASE: ReleaseNote = {
  version: '1.0.10',
  date: '2026-06-06',
  notes: {
    en: {
      title: 'Release Highlights',
      items: [
        'Fixed issue with point calculation when doing the same question repeatedly',
        'Updated May leaderboard',
        'Fixed several stability issues',
        'Fixed issue with incorrect unit and knowledge point in question selection',
        'Fixed issue with no spaces in English questions',
        'Fixed issue with inaccurate smart grading for fill-in-the-blank questions',
        'Optimized the interface for creating multiple-choice questions',
        'Optimized the number of assignments displayed on the student side',
        'Fixed issue with incorrect assignment time on student calendar',
      ],
    },
    'zh-HK': {
      title: '版本更新',
      items: [
        '修復反復做同一題目的積分計算問題',
        '更新5月份積分排行榜',
        '修復若干穩定性問題',
        '修復選題單元與知識點錯誤問題',
        '修復英文題目顯示無空格問題',
        '修復填空題智能批改不准問題',
        '優化創建選擇題界面',
        '優化學生端作業顯示數量',
        '修復學生端日曆作業時間錯誤問題',
      ],
    },
    'zh-CN': {
      title: '版本更新',
      items: [
        '修复反复做同一题目的积分计算问题',
        '更新5月份积分排行榜',
        '修复若干稳定性问题',
        '修复选题单元与知识点错误问题',
        '修复英文题目显示无空格问题',
        '修复填空题智能批改不准问题',
        '优化创建选择题界面',
        '优化学生端作业显示数量',
        '修复学生端日历作业时间错误问题',
      ],
    },
  },
};

const RELEASE_NOTES_STORAGE_KEY = 'eeelt_last_seen_version';

/**
 * Check if the current release notes should be shown to the user
 */
export function shouldShowReleaseNotes(): boolean {
  const lastSeenVersion = localStorage.getItem(RELEASE_NOTES_STORAGE_KEY);
  return lastSeenVersion !== CURRENT_RELEASE.version;
}

/**
 * Mark the current release notes as seen
 */
export function markReleaseNotesAsSeen(): void {
  localStorage.setItem(RELEASE_NOTES_STORAGE_KEY, CURRENT_RELEASE.version);
}
